import { get as getCookie } from '../cookies'

export const isInternal = () => {return (getCookie("fake") === "true") || (getCookie("internalUser") && getCookie("internalUser") === "true")}